/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlValidationError } from './ControlValidationError';
import {
    ControlValidationErrorFromJSON,
    ControlValidationErrorFromJSONTyped,
    ControlValidationErrorToJSON,
} from './ControlValidationError';

/**
 * 
 * @export
 * @interface ControlHTTPValidationError
 */
export interface ControlHTTPValidationError {
    /**
     * 
     * @type {Array<ControlValidationError>}
     * @memberof ControlHTTPValidationError
     */
    detail?: Array<ControlValidationError>;
}

/**
 * Check if a given object implements the ControlHTTPValidationError interface.
 */
export function instanceOfControlHTTPValidationError(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlHTTPValidationErrorFromJSON(json: any): ControlHTTPValidationError {
    return ControlHTTPValidationErrorFromJSONTyped(json, false);
}

export function ControlHTTPValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlHTTPValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'detail': !exists(json, 'detail') ? undefined : ((json['detail'] as Array<any>).map(ControlValidationErrorFromJSON)),
    };
}

export function ControlHTTPValidationErrorToJSON(value?: ControlHTTPValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'detail': value.detail === undefined ? undefined : ((value.detail as Array<any>).map(ControlValidationErrorToJSON)),
    };
}

